import { memo } from 'react';
import { useIntl } from 'react-intl';
import { Box, Typography } from '@rossum/ui/material';
import { CollapsibleSection } from './CollapsibleSection';
import { MarkdownRenderer } from './MarkdownRenderer';

type CollapsibleReasoningProps = {
  content: string;
  isReasoningRedacted?: boolean;
};

const CollapsibleReasoningComponent = ({
  content,
  isReasoningRedacted = false,
}: CollapsibleReasoningProps) => {
  const intl = useIntl();

  return (
    <CollapsibleSection
      data-cy="chat-reasoning-accordion"
      sx={{ mb: 1 }}
      label={intl.formatMessage({
        id: 'features.chat.collapsibleBlock.thoughtProcess',
      })}
    >
      <Box sx={{ mt: 0.5, pl: 2.5, pr: 1, maxHeight: 300, overflow: 'auto' }}>
        <Typography component="div" variant="body2" color="text.secondary">
          {content && <MarkdownRenderer content={content} />}
          {isReasoningRedacted && (
            <Typography
              variant="body2"
              color="text.secondary"
              fontStyle="italic"
            >
              {intl.formatMessage({
                id: 'features.chat.collapsibleReasoning.reasoningRedacted',
              })}
            </Typography>
          )}
        </Typography>
      </Box>
    </CollapsibleSection>
  );
};

export const CollapsibleReasoning = memo(CollapsibleReasoningComponent);
